export default {
  // 表单标签
  address: "地址:",
  blockchain: "所属链:",
  currency: "币种:",
  monitorCondition: "监控条件:",
  monitorDirection: "监控方向",
  monitorName: "监控名称:",
  relatedCase: "关联案件(选填)",
  remark: "备注",
  monitorType: "监控类型:",
  pushChannel: "推送渠道:",

  // 占位符
  inputAddress: "请输入地址",
  selectBlockchain: "请选择主链",
  selectCurrency: "请选择币种",
  minAmount: "最小金额",
  maxAmount: "最大金额",
  inputMonitorName: "请输入监控名称",
  selectRelatedCase: "请选择关联案件",
  inputRemark: "请输入备注内容",
  pleaseSelect: "请选择",

  // 监控方向
  bidirectional: "双向",
  inflow: "流入",
  outflow: "流出",

  // 监控类型
  commonMonitor: "普通监控（交易信息实时更新，无推送功能）",
  realtimeMonitor: "实时监控（交易信息实时更新和推送，可选择下方推送渠道）",

  // 推送渠道
  dingtalk: "钉钉",
  email: "邮箱",
  wechat: "微信",
  dingtalkHelp: "如何获取钉钉群机器人签名密钥和Webhook地址？",
  inputDingtalkSecret: "请输入钉钉群机器人签名密钥",
  inputDingtalkWebhook: "请输入钉钉机器人Webhook地址",
  inputDingtalkPhone: "请输入钉钉手机号(非必填,钉钉群推送可艾特到指定人)",
  inputEmail: "请输入邮箱地址",

  // 微信绑定
  bound: "已绑定",
  toBind: "待绑定，",
  clickToBind: "点击扫码绑定微信",

  // 按钮
  return: "返回",
  confirm: "确认",

  // 对话框
  dialogTitle: "钉钉添加机器人操作说明",

  // 提示信息
  maxAmountTip: "最大金额需≥最小金额",
  maxValueTip: "最大值要比最小值大",
  pleaseBindWechat: "请先绑定微信",
  pleaseSelectChannel: "请选择渠道",
  addMonitorSuccess: "添加监控成功",

  // 表单验证
  inputMonitorNameRequired: "请输入监控名称",
  monitorNameLength: "长度在 1 到 20 个字符",
  selectBlockchainRequired: "请选择主链",
  inputAddressRequired: "请输入地址",
  minAmountRequired: "最小金额不能为空",
  maxAmountRequired: "最大金额不能为空",
  selectMonitorDirection: "请选择监控方向",
  inputRemarkContent: "请填写备注内容",
  selectMonitorType: "请选择监控类型",
  inputCorrectEmail: "请输入正确的邮箱地址",
  inputCorrectPhone: "请输入正确的手机号码",
  inputValidPhone: "请输入合法手机号/电话号",
  inputDingtalkSecretRequired: "请输入钉钉群机器人签名密钥",
  inputDingtalkWebhookRequired: "请输入钉钉地址",
};
